import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.users
)

export const selectUsers = createSelector(
    baseSelector,
    (state) => state.users
)
export const selectUsersError = createSelector(
    baseSelector,
    (state) => state.usersError
)
export const selectUsersLoading = createSelector(
    baseSelector,
    (state) => state.isUsersLoading
)
export const selectUsersFirstLoad = createSelector(
    baseSelector,
    (state) => state.isUsersFirstLoad
)
export const selectEmployees = createSelector(
    baseSelector,
    (state) => state.employees
)
export const selectEmployeesError = createSelector(
    baseSelector,
    (state) => state.employeesError
)
export const selectEmployeesLoading = createSelector(
    baseSelector,
    (state) => state.isEmployeesLoading
)
export const selectEmployeesFirstLoad = createSelector(
    baseSelector,
    (state) => state.isEmployeesFirstLoad
)
export const selectEmployeesCurrentGroup = createSelector(
    baseSelector,
    (state) => state.employeesGroup
)
export const selectEmployeesCurrentPage = createSelector(
    baseSelector,
    (state) => state.employeesPage
)
export const selectEmployeesTotalPages = createSelector(
    baseSelector,
    (state) => state.employeesTotalPages
)
export const selectEmployeesTotalCount = createSelector(
    baseSelector,
    (state) => state.employeesTotalCount
)
export const selectEmployeesSearch = createSelector(
    baseSelector,
    (state) => state.employeesSearch
)
export const selectUsersCurrentGroup = createSelector(
    baseSelector,
    (state) => state.usersGroup
)
export const selectUsersCurrentPage = createSelector(
    baseSelector,
    (state) => state.usersPage
)
export const selectUsersTotalPages = createSelector(
    baseSelector,
    (state) => state.usersTotalPages
)
export const selectUsersTotalCount = createSelector(
    baseSelector,
    (state) => state.usersTotalCount
)
export const selectUsersSearch = createSelector(
    baseSelector,
    (state) => state.usersSearch
)
export const selectUsersBlockStatus = createSelector(
    baseSelector,
    (state) => state.usersBlockStatus
)
export const selectUsersDeletedStatus = createSelector(
    baseSelector,
    (state) => state.usersDeletedStatus
)
export const selectUsersAttractedStatus = createSelector(
    baseSelector,
    (state) => state.usersAttractedStatus
)
export const selectEmployeesBlockStatus = createSelector(
    baseSelector,
    (state) => state.employeesBlockStatus
)
export const selectSelectedUsersForReport = createSelector(
    baseSelector,
    (state) => state.selectedUsersForReport
)
export const selectSelectedUserIdsForReport = createSelector(
    baseSelector,
    (state) => state.selectedUsersForReport.map(user => user.id)
)
export const selectIsReportGenerationMode = createSelector(
    baseSelector,
    (state) => state.isReportGenerationMode
)
